export default {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    // identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
    // REQUIRED - Amazon Cognito Region
    region: 'ap-northeast-1',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    // authenticationFlowType: 'USER_SRP_AUTH',
    // ★TODO LM Cognito1段階目移行の期間終了後、「USER_PASSWORD_AUTH」⇒「USER_SRP_AUTH」似戻す
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    // OPTIONAL - Hosted UI configuration
    oauth: {
      responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
    }
  }
}
